import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

/**
 * A service used to return sport specific information. Such as a list
 * of features that are available for a given sport.
 */
@Injectable()
export class ConfigurationService {
    private currentSport: string = null;

    /**
     * Constructor
     */
    constructor() {
        this.currentSport = environment.currentSport;

        if (environment.currentSport === 'dynamic') {
            this.currentSport = location.host.includes('flograppling') ? 'flograppling' : 'flowrestling';
        }
    }

    public getBaseConfig(key: string): any {
        return environment[key];
    }

    public getStripeConfig(key: string): any {
        return environment.stripe[key];
    }

    public getSportConfig(key: string): any {
        // could be based on URL flograppling vs flowrestling when in production
        // both of the domain can point to the same instance in kubenetes
        // when getting hit by request, it should served differently based on url
        const sportConfig: any = environment.sports[this.currentSport];

        if (!sportConfig) {
            console.warn(`Sport (${this.currentSport}) is NOT configured!`);
            return null;
        }

        return sportConfig[key];
    }

    public getSportParticipantName(): string {
        return this.getSportConfig('participantAliasName');
    }

    public getSportParticipantNamePlural(): string {
        return this.getSportConfig('participantAliasNamePlural');
    }

    /**
     * Get the base api for the current sport.
     */
    public getApiBaseUrl(): string {
        return this.getBaseConfig('floArenaApiUrl');
    }

    /**
     * Get the url for downloading FloArena
     */
    public getDownlaodFloArenaUrl(): string {
        return this.getBaseConfig('downloadFloArenaUrl');
    }

    /**
     * get the base api for the core service
     */
    public getCoreApiBaseUrl(): string {
        return this.getBaseConfig('floCoreApiUrl');
    }

    /**
     * get the base api for the flo hub
     */
    public getFloEventHubBaseUrl(): string {
        return this.getBaseConfig('floEventHubBaseUrl');
    }
}
